import styled from 'styled-components';

import { topicGutterCss, transcriptHeaderGutterCss } from './topicRailStyles';

/**
 * The transcript's two left-edge-defining chrome elements, extracted from
 * `Transcript.tsx` (PLAT-11039) per CLAUDE.md → "Architecture Guardrails"
 * rule 5.
 *
 * They belong together: both take the same `$topicGutter` flag, and that is
 * what keeps the toolbar and the transcript text on one vertical line. The
 * header adds the cursor allowance the text carries inside its wrapper — see
 * `topicRailStyles` for the arithmetic.
 */

/** Toolbar row: search, undo/redo, marking toggles, filters, translation. */
export const Header = styled.div<{ $topicGutter?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 32px;
  flex-shrink: 0;
  margin-bottom: 8px;
  ${transcriptHeaderGutterCss}
`;

/**
 * Right-pinned end of the header row (translation controls, overflow). The
 * flexible gap before it absorbs the filter group's width changes, so these
 * controls never shift (PLAT-11039).
 */
export const HeaderTail = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
  margin-left: auto;
  flex-shrink: 0;
`;

/**
 * The scrolling transcript body. `overflow-y: scroll` computes `overflow-x` to
 * `auto`, so it clips at its padding box — which is exactly why the topic rail
 * gutter is padding here rather than a negative offset into an ancestor.
 */
export const ScrollableText = styled.div.withConfig({
  displayName: 'ScrollableText',
})<{ $topicGutter?: boolean }>`
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  ${topicGutterCss}
  padding-right: 14px;
  padding-bottom: 42px;
  box-sizing: border-box;
  line-height: 175%;
  margin-top: 4px;
  float: left;
  position: relative;

  &::-webkit-scrollbar {
    width: 12px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.4);
  }
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
`;
